const LanguageStatus = {
  draft: 'draft',
  exporting: 'exporting',
  importing: 'importing',
  published: 'published'
};
module.exports = LanguageStatus;